/**
 * Library Constants
 * Shared configuration for AURA Master Library, Tenant Regulatory Library, and Policy Library
 */
import {
  Coins, UsersFour, Lock, Handshake, Shield, Buildings, Bank, Brain, Globe, Leaf,
  Scales, Scroll, FileText, ListBullets, BookOpen, Certificate, Folders, Files, Receipt
} from '@phosphor-icons/react';

// ============================================
// REGULATORY/POLICY THEMES (Unified for all libraries)
// ============================================
export const REGULATORY_THEMES = [
  { id: 'AML_CFT_PF', code: 'AML', label: 'AML/CFT/PF', icon: Coins, color: '#F59E0B' },
  { id: 'Consumer_Protection', code: 'CON', label: 'Consumer Protection', icon: UsersFour, color: '#3B82F6' },
  { id: 'Data_Privacy', code: 'DAT', label: 'Data Privacy', icon: Lock, color: '#EC4899' },
  { id: 'Conduct', code: 'COD', label: 'Conduct Risk', icon: Handshake, color: '#14B8A6' },
  { id: 'Cybersecurity', code: 'CYB', label: 'Cyber Security', icon: Shield, color: '#06B6D4' },
  { id: 'Governance', code: 'GOV', label: 'Governance', icon: Buildings, color: '#D4A843' },
  { id: 'Capital_Liquidity', code: 'CAP', label: 'Capital & Liquidity', icon: Bank, color: '#0891B2' },
  { id: 'AI_Governance', code: 'AIG', label: 'AI Governance', icon: Brain, color: '#A855F7' },
  { id: 'FATCA_CRS', code: 'FAT', label: 'FATCA/CRS', icon: Globe, color: '#6366F1' },
  { id: 'Social_Impact', code: 'SOC', label: 'Social Impact', icon: Leaf, color: '#10B981' },
  { id: 'Tax_Compliance', code: 'TAX', label: 'Tax Compliance', icon: Receipt, color: '#EF4444' },
];

// Alias for Policy Library (uses same themes)
export const POLICY_THEMES = REGULATORY_THEMES;

// ============================================
// DOCUMENT TYPES
// ============================================
export const DOCUMENT_TYPES = [
  { id: 'act', code: 'ACT', label: 'Acts', singular: 'Act', icon: Scales, color: '#EF4444' },
  { id: 'regulation', code: 'REG', label: 'Regulations', singular: 'Regulation', icon: Scroll, color: '#F59E0B' },
  { id: 'directive', code: 'DIR', label: 'Directives', singular: 'Directive', icon: FileText, color: '#8B5CF6' },
  { id: 'circular', code: 'CIR', label: 'Circulars', singular: 'Circular', icon: ListBullets, color: '#06B6D4' },
  { id: 'guideline', code: 'GUI', label: 'Guidelines', singular: 'Guideline', icon: BookOpen, color: '#10B981' },
  { id: 'standard', code: 'STD', label: 'Standards', singular: 'Standard', icon: Certificate, color: '#3B82F6' },
  { id: 'policy', code: 'POL', label: 'Policies', singular: 'Policy', icon: Shield, color: '#EC4899' },
  { id: 'framework', code: 'FRM', label: 'Frameworks', singular: 'Framework', icon: Folders, color: '#14B8A6' },
  { id: 'other', code: 'OTH', label: 'Other', singular: 'Other', icon: Files, color: '#6B7280' },
];

// ============================================
// REGULATORS
// ============================================
export const REGULATORS = [
  { id: 'FIC', code: 'FIC', label: 'Financial Intelligence Centre' },
  { id: 'SARB', code: 'SAR', label: 'South African Reserve Bank' },
  { id: 'FSCA', code: 'FSC', label: 'Financial Sector Conduct Authority' },
  { id: 'PA', code: 'PRA', label: 'Prudential Authority' },
  { id: 'GEN', code: 'GEN', label: 'General / Multiple' },
];

// ============================================
// HELPER FUNCTIONS
// ============================================

/**
 * Check if document is draft based on title
 */
export const isDraftDocument = (title) => {
  if (!title) return false;
  return title.toUpperCase().includes('DRAFT');
};

/**
 * Get document type config by ID
 */
export const getDocTypeConfig = (typeId) => {
  return DOCUMENT_TYPES.find(t => t.id === typeId?.toLowerCase()) || DOCUMENT_TYPES[8];
};

/**
 * Get theme config by ID
 */
export const getThemeConfig = (themeId) => {
  return REGULATORY_THEMES.find(t => t.id === themeId) || REGULATORY_THEMES[0];
};

/**
 * Get regulator config by ID
 */
export const getRegulatorConfig = (regulatorId) => {
  return REGULATORS.find(r => r.id === regulatorId) || REGULATORS[4];
};
